const { mbcAccount } = window;
export default class TksAccout {
  /**
   * @param {Object} options
   * @param {Promise} options.authPromise
   * @param {String} options.env
   * @param {String} options.ssoProxyPath
   * @param {String} options.platformId
   */
  constructor(options) {
    this.options = options;
    this.response = null;
  }

  /**
   * @param {Object} options
   * @param {Promise} options.getAuthorization
   * @param {String} options.env
   * @param {String} options.ssoProxyPath
   * @param {String} options.platformId
   */
  init(options) {
    this.options = {
      ...this.options,
      ...options,
    };
    this.setEnv(this.options.env);
  }

  setEnv(env) {
    mbcAccount.setEnv(env);
  }

  async getAuthorization() {
    if (this.response) {
      return Promise.resolve(this.response);
    }
    this.response = await this.options.authPromise(this.options, this);
    return this.response;
  }

  /**
   * 登出
   */
  logout(fail) {
    mbcAccount.logout({
      platformId: this.options.platformId,
      fail,
    });
  }

  apply() {
    mbcAccount.apply({
      platformId: this.options.platformId,
    });
  }

  /**
   * 跳转到登录页面
   */
  login() {
    mbcAccount.login({
      platformId: this.options.platformId,
      mapssoproxy: this.options.ssoProxyPath,
    });
  }

  /**
   * 跳转到个人中心页面
   */
  jumpUserCenter() {
    mbcAccount.jumpUserCenter();
  }
}
